module.exports = __webpack_public_path__ + "img/mini_ico_1.73d526ff.svg";